import React from 'react';
import CtPolicyTable from './table/CtPolicyTable';

const PolicyContent: React.FC = () => {
  return <CtPolicyTable />;
};

export default PolicyContent;
